import { CircularProgress, Paper, Stack, Typography } from '@mui/material'
import { useState } from 'react'
import { useAuth } from '../../../../hooks/use-auth'
import { useP2PInvitations } from '../../../../hooks/use-p2pInvitations'
import { DueDateNotice } from './DueDateNotice'
import { InviteForm } from './InviteForm'
import { InviteeTable } from './InviteeTable'
import { styles } from './InviteeList.styles'

export const InviteeList = (): JSX.Element => {
  const { user } = useAuth()
  const { year, invitees, isLoading, isSending, send, resend, revoke } = useP2PInvitations(user?.currentOrgId ?? 0)
  const [noticeDismissed, setNoticeDismissed] = useState<boolean>(false)

  if (isLoading) return <CircularProgress />

  const acceptedCount = invitees.filter(invitee => invitee.status === 'Accepted').length

  return (
    <Paper variant='outlined' sx={styles.page} data-testid='p2pInviteeList'>
      <Typography variant='h3'>Overview</Typography>
      <Typography variant='body2' color='text.secondary' sx={styles.intro}>
        START gathers Peer to Peer data each school year to better understand Peer to Peer implementation across Michigan.
        Invite the District Users who will report data for your ISD, and track their progress below.
      </Typography>

      {!noticeDismissed &&
        <DueDateNotice dueDate={year?.softDueDate ?? year?.endDate} onDismiss={() => { setNoticeDismissed(true) }} />}

      <Stack direction={{ xs: 'column', md: 'row' }} gap='20px' alignItems='stretch'>
        <InviteForm isSending={isSending} onSend={send} />

        <Paper variant='outlined' sx={styles.panel}>
          <Stack direction='row' justifyContent='space-between' alignItems='baseline' mb='8px'>
            <Typography variant='h4'>Invited Users</Typography>
            <Typography variant='body2' color='text.secondary' data-testid='p2pInviteeCount'>{invitees.length} invited · {acceptedCount} accepted</Typography>
          </Stack>
          {invitees.length === 0
            ? <Typography variant='body1'>No invitations yet.</Typography>
            : <InviteeTable invitees={invitees} onResend={id => { void resend(id) }} onRevoke={id => { void revoke(id) }} />}
        </Paper>
      </Stack>
    </Paper>
  )
}
